import {FormField} from "../form-field/form-field";
import {GvfService} from "../../../gvf/js/gvf-service";

export class FormFieldDate extends FormField{
	constructor(scope,$root){
        super(scope,$root);
        this.$input = null;
        this.$inputValue = null;
        this.$emptyButton = null;
        this.noEvent = false;
    }

    applyInputFormat(picker){
        if(this.$root.hasClass("is-date-range")){
            this.$input.val(picker.startDate.format(this.options.locale.format)+" - "+picker.endDate.format(this.options.locale.format));
        }else{
            this.$input.val(picker.startDate.format(this.options.locale.format));
        }
    }

    getVal(){
        return this.$inputValue.val();
    }

    setVal(val,noEvent){
        if(val){
            const picker = this.$input.data('daterangepicker');
            if(this.$root.hasClass("is-date-range")){
                const range = $.isArray(val)?val:JSON.parse(val);
                picker.setStartDate(moment(range[0]).format(this.options.locale.format));
                picker.setEndDate(moment(range[1]).format(this.options.locale.format));
                this.$inputValue.val(JSON.stringify(range));
            }else{
                picker.setStartDate(moment(val).format(this.options.locale.format));
                this.$inputValue.val(val);
            }
            this.noEvent = noEvent;
            this.applyInputFormat(picker);
        }else{
            this.$input.val("");
            this.$inputValue.val("");
            if(!noEvent){
                this.$root.trigger("formField:changeVal");
            }
        }
    }

    ready(){
        super.ready();
        this.$input = this.findMember("input");
        this.$inputValue = this.findMember("input-value");
        this.$emptyButton = this.findMember("empty");
        this.options = {
            showDropdowns: true,
            singleDatePicker: true,
            autoUpdateInput: false,
            locale: {
                format: "DD/MM/YYYY",
                separator: " - ",
                applyLabel: this.$root.data("button-apply"),
                cancelLabel: this.$root.data("button-cancel"),
                fromLabel: GvfService.lang("Desde"),
                toLabel: GvfService.lang("Hasta"),
                customRangeLabel: GvfService.lang("Personalizar"),
                weekLabel: "S",
                firstDay: 1,
                daysOfWeek: this.$root.data("days-lang"),
                monthNames: this.$root.data("months-lang"),
            }
        };
        if(this.$root.hasClass("is-date-time")){
            this.options.timePicker = true;
            this.options.timePicker24Hour = true;
            this.options.locale.format = "DD/MM/YYYY H:mm";
        }else if(this.$root.hasClass("is-date-range")){
            this.options.singleDatePicker = false;
            this.options.opens = "center";
        }

        this.$input.daterangepicker(this.options);
        //disable events if readonly or disabled
        if(this.$input.prop("readonly")){
            this.$input.css("pointer-events","none");
        }

        this.findMember("empty").click(
            (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.formFieldSetVal("");
            }
        );

        this.$input.on(
            "apply.daterangepicker",
            (ev,picker)=>{
                let format = 'YYYY-MM-DD';
                if(this.$root.hasClass("is-date-time"))
                    format = 'YYYY-MM-DD HH:mm:00';

                if(this.$root.hasClass("is-date-range")){
                    this.$inputValue.val(JSON.stringify([picker.startDate.format(format),picker.endDate.format(format)]));
                }else{
                    this.$inputValue.val(picker.startDate.format(format));
                }
                this.applyInputFormat(picker);
                if(!this.noEvent){
                    this.$root.trigger("formField:changeVal");
                }
            }
        );

        if(this.$inputValue.val()){
            this.setVal(this.$inputValue.val());
        }

        this.$emptyButton.prop("disabled",this.$root.hasClass("is-disabled"));

        this.$root.on(
            "formField:bindDisable formField:bindEnable",
            ()=>{
                this.$emptyButton.prop("disabled",this.$root.hasClass("is-disabled"));
            }
        );

        this.$root.on(
            "change",
            ()=>{
                const text = this.$input.val();
                if(!text){
                    this.setVal("");
                    return;
                }
                const dates = this.$root.hasClass("is-date-range")?text.split(this.options.locale.separator):[text];
                if(!dates.every((date)=>moment(date,this.options.locale.format).isValid())){ //the picker would apply its stale date instead
                    this.setVal(this.getVal());
                    return;
                }
                const picker = this.$input.data('daterangepicker');
                picker.elementChanged(); //the picker only parses the text on keyup: pasted or autofilled dates would be lost
                picker.clickApply();
            }
        );
    }
}
